export const useHubspotToken = () => {
	return document.cookie.replace(
		/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/,
		"$1"
	);
};
